import request from '@/axios'
import qs from 'qs'


/**
 * @Description: 提交验证
 * @author Li Yanjie
 * @date 2020/7/9
 * @param data {Object}
 * @return Promise
 */
export function registerProduct(data){
  return request({
    method:'post',
    url:'/api/product/registerProduct',
    data:data
  })
}


/**
 * @Description: 根据账号获取提交记录
 * @author Li Yanjie
 * @date 2020/7/9
 * @param proposer {Object} 申请对象的用户名
 * @return Promise
 */
export function getRegisterByProposer(proposer){
  return request({
    method:'get',
    url:'/api/product/getRegisterByProposer',
    params:{proposer}
  })
}

/**
 * @Description: 获取该账号激活logic的次数
 * @author LJQ
 * @date 2025/03/27
 * @param proposer {Object} 手机号
 * @return Promise
 */
export function getLogicActiveNumber(data){
  return request({
    method:'post',
    url:'/api/product/getLogicActiveNumber',
    params: data
  })
}

